/**
 * useAddresses
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import AddressesContext from './addresses-context'

const useAddresses = () => {
  const context = useContext(AddressesContext)
  return context
}

export default useAddresses
